import React from 'react';

const PhoneChangeSeparator = ({ previousPhoneName, currentPhoneName }) => {
  if (!previousPhoneName || !currentPhoneName) {
    return null;
  }

  return (
    <div className='flex items-center justify-center my-3'>
      <div className='flex items-center gap-2 w-full max-w-md'>
        <div className='flex-1 h-px bg-gray-300'></div>
        <div className='bg-blue-50 border border-blue-200 text-blue-700 text-xs px-3 py-1 rounded-full whitespace-nowrap'>
          📱 Cambio de {previousPhoneName} a {currentPhoneName}
        </div>
        <div className='flex-1 h-px bg-gray-300'></div>
      </div>
    </div>
  );
};

export default PhoneChangeSeparator;

